import { PatientWorkQueueItem } from '../PatientWorkQueue.types';

export const sortByTAT = (
  a: PatientWorkQueueItem,
  b: PatientWorkQueueItem
): number => {
  const valueA = a.minutes_until_deadline;
  const valueB = b.minutes_until_deadline;

  if (valueA === null && valueB === null) return 0;
  if (valueA === null) return 1;
  if (valueB === null) return -1;

  return valueA - valueB;
};

export const sortByP2PDate = (
  a: PatientWorkQueueItem,
  b: PatientWorkQueueItem
) => {
  const valueA = a.peer_to_peer_deadline_date;
  const valueB = b.peer_to_peer_deadline_date;

  if (valueA === null && valueB === null) return 0;
  if (valueA === null) return 1;
  if (valueB === null) return -1;

  const dateA = new Date(valueA).getTime();
  const dateB = new Date(valueB).getTime();

  return dateA - dateB;
};
